import { PiFunnelThin } from 'react-icons/pi';
import { IconType } from 'react-icons';
import { Filter } from '@ais-ui/websockets';
import { getFilterType } from './getFilterType';
import { filterOptionsTemplate } from './constants';

export const filterToIcon = (filter: Filter): React.ElementType => {
  const filterType = getFilterType(filter);
  const upperCaseFilterType = filterType.toUpperCase();
  let IconComponent: IconType = PiFunnelThin;
  if (filterOptionsTemplate.hasOwnProperty(upperCaseFilterType)) {
    IconComponent = filterOptionsTemplate[upperCaseFilterType].icon;
  }

  return IconComponent;
};
